<div [formGroup]="experimentDesignFormGroup">
  <div class="form-group">
    <label class="control-label col-sm-2">Start Date
      <a tooltip="Value taken from Desired Planting Date set under Experiment Details"
        placement="right"
        container="body">
        <span class="glyphicon glyphicon-info-sign"></span>
      </a>
    </label>
    <div class="col-sm-10">
      <p class="form-control-static">{{!plantingDate ? 'No planting date set' : plantingDate | date: 'MM/dd/yyyy'}}
      </p>
    </div>
  </div>

  <div class="form-group">
    <label class="col-sm-2 control-label">Pattern</label>
    <div class="col-sm-2">
      <label class="radio-inline"><input name="recurrencePattern" [value]="recurrenceNone" type="radio" formControlName="recurrencePattern">None</label>
      <label class="radio-inline"><input name="recurrencePattern" [value]="recurrenceWeekly" type="radio" formControlName="recurrencePattern">Weekly</label>  
    </div>
  </div>
  
  <div *ngIf="recurrencePattern.value === 2">
    <div class="form-group" [class.has-error]="recurrenceWeekInterval.invalid">
      <div class="form-inline col-sm-10 col-sm-offset-2">
        <span>
          Every
          <input type="text" class="form-control" formControlName="recurrenceWeekInterval" size="3" maxlength="3" appIntegerValueAccessor />
          week(s)
          <br>
        </span>
        <div class="alert alert-danger" 
          *ngIf="recurrenceWeekInterval.errors?.min">
          Number of weeks must be at least {{ recurrenceWeekInterval.errors?.min.min }}
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-10 col-sm-offset-2">
        <span formArrayName="recurrenceDays">on: 
          <label 
            *ngFor="let day of recurrenceDays.controls; let i = index" 
            class="checkbox-inline">
            <input type="checkbox" [formControlName]="i">{{dayNames[i]}}
          </label>
        </span>
      </div>
    </div>
    
    <div class="form-group" [class.has-error]="recurrenceEndDate.invalid">
      <label class="col-sm-2 control-label">End Date</label>
      <app-ce-date-picker
        [formControl]="recurrenceEndDate"
        [minDate]="minEndDate"
        [maxDate]="maxEndDate">
      </app-ce-date-picker>
    </div>
    <div class="alert alert-danger col-sm-offset-2" 
      *ngIf="!plantingDate">
      Planting Date must be set under experiment details tab
    </div>
    <div class="alert alert-danger col-sm-offset-2" 
      *ngIf="!recurrenceEndDate.pristine && recurrenceEndDate.errors?.min">
        End Date must be after Start Date
    </div>
    <div class="alert alert-danger col-sm-offset-2" 
      *ngIf="recurrenceEndDate.errors?.max">
      End Date must be within 30 days of Start Date
    </div>
    <div class="alert alert-danger col-sm-offset-2" 
      *ngIf="recurrenceEndDate.errors?.dayOfWeek">
        End Date must be a day of the week allowed by the recurrence pattern
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/recurrence/recurrence.component.html